import { Component, OnInit, Renderer2, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'z-shopping-cart-modal',
  templateUrl: './shopping-cart-modal.component.html',
  styleUrls: ['./shopping-cart-modal.component.scss'],
  standalone: false,
})
export class ShoppingCartModalComponent implements OnInit, OnDestroy {
  title: string;
  content: string;
  sourcePage: string;

  showContinueShoppingButton = true;

  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private renderer: Renderer2,
    private router: Router
  ) { }

  ngOnInit() {
    this.renderer.addClass(document.body, 'cart-modal-open');
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'cart-modal-open');
  }

  onCheckOut() {
    // Dismiss all open modals (e.g. the Compare modal this popup may be layered
    // on top of), not just this one, so navigating to the cart doesn't leave
    // another modal open behind it.
    this.modalService.dismissAll();
    this.router.navigateByUrl('/marketplace/shoppingcart', { state: { source: this.sourcePage } });
  }
}
